import { RegistrationDownArrow } from 'assets/icons';
import { FormikErrors, FormikTouched } from 'formik';
import { useState } from 'react';
import './styles.scss';

interface CheckboxProps {
	name: string;
	label: string;
	values: any;
	setFieldValue: (field: string, val: any) => void;
	errors: FormikErrors<{ [field: string]: any }>;
	isFieldValueValid: (field: string, errors: any, touched: {}) => boolean;
	touched: FormikTouched<{}>;
	onChange?: (e: any) => void;
	description?: any;
	cyTestRef?: string;
}

export default function Checkbox(props: CheckboxProps) {
	const { name, label, values, setFieldValue, isFieldValueValid, errors, touched, onChange, description, cyTestRef } = props;
	const isError = isFieldValueValid(name, errors, touched);
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className={!isError ? 'inputCheckbox' : 'inputCheckbox inputCheckbox--error'}>
			<div className={`inputCheckbox__inner ${description ? 'inputCheckbox__inner--wide' : 'inputCheckbox__inner--small'}`}>
				<input
					className="inputCheckbox__input"
					type="checkbox"
					id={name}
					name={name}
					checked={values[name]}
					onChange={onChange ? onChange : (e: any) => setFieldValue(name, e.target.checked)}
					data-cy={cyTestRef}
				/>
				<label htmlFor={name} className="inputCheckbox__label" dangerouslySetInnerHTML={{ __html: label }} />
				<span className="inputCheckbox__field" />
				{description && (
					<div
						className={!isOpen ? 'inputCheckbox__icon' : 'inputCheckbox__icon inputCheckbox__icon--rotated'}
						onClick={(event) => {
							event.stopPropagation();
							event.preventDefault();
							setIsOpen(!isOpen);
						}}
					>
						<RegistrationDownArrow className="stroke-white text-white" />
					</div>
				)}
			</div>
			{description && (
				<div className={!isOpen ? 'inputCheckbox__description' : 'inputCheckbox__description inputCheckbox__description--open'}>
					{description}
				</div>
			)}
		</div>
	);
}
